import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { Common } from '../../../../../core/common';
import { IHeaderProps } from '../../../../../models/components/add-activity-survey-questions';
import { IAction, IAppState } from '../../../../../models/action/core';
import { connect } from 'react-redux';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;
const titleCharLimit: number = 255;

interface ITitle {
    titleLengthError: boolean;
}

export class Header extends Component<IHeaderProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.props.deleteQuestion.bind(this);
    }
    public state: ITitle = {
        titleLengthError: false
    };

    handleDelete = () => {
        this.props.deleteQuestion(this.props.question.displayOrder, false, T.t('r_delete_survey_question_header'));
    };

    onChange = (e: any) => {
        if (e && e.target) {
            if (e.target.value.length <= titleCharLimit) {
                const question = this.props.question;
                question.description = e.target.value;
                this.props.editQuestion(question);
                if (this.state.titleLengthError) {
                    this.setState({ titleLengthError: false });
                }
            } else if (!this.state.titleLengthError) {
                this.setState({ titleLengthError: true });
            }
        }
    };

    onEdit = () => {
        const item = document.getElementById('survey_header_' + this.props.question.displayOrder);
        if (item) {
            item.focus();
        }
    };

    public render() {
        return (
            <React.Fragment>
                <div className="w-85 ">
                    <div className="form-input form-group">
                        <div className="form-input form-group survey_input_padding">
                            <input type="text" required={true} onChange={this.onChange} value={this.props.question.description} />
                            <span className="highlight" />
                            <span className="bar" />
                            <label  className='label-spacing'>{T.t('r_activity_survey_header_placeholder')}</label>
                        </div>
                    </div>
                    {this.state.titleLengthError && <label className="error">{T.t('r_title_max_char')}</label>}
                </div>
                <div>
                    <div className="btn_container">
                        <span className="move_btn" {...this.props.dragHandleProps}>
                            <i className="material-icons">open_with</i>
                        </span>
                        <span className="delete_btn" onClick={this.handleDelete}>
                            <i className="material-icons">close</i>
                        </span>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHeaderProps): IHeaderProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHeaderProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CHeader = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Header);

export default CHeader;
